import { useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import Layout from "./components/Layout";
import { initWhatsAppEnquiry } from "./utils/whatsapp";

import Home from "./pages/Home";
import About from "./pages/About";
import Projects from "./pages/Projects";
import OngoingProjects from "./pages/OngoingProjects";
import CompleteProjects from "./pages/CompleteProjects";
import UpcomingProjects from "./pages/UpcomingProjects";
import ParkGrandeur from "./pages/ParkGrandeur";
import News from "./pages/News";
import Careers from "./pages/Careers";
import Contact from "./pages/Contact";

function App() {
  const location = useLocation();

  useEffect(() => {
    const t = setTimeout(() => {
      initWhatsAppEnquiry();
      const Car = window.bootstrap && window.bootstrap.Carousel;
      if (Car && typeof Car.getOrCreateInstance === "function") {
        document
          .querySelectorAll('[data-bs-ride="carousel"]')
          .forEach((el) => {
            Car.getOrCreateInstance(el);
          });
      }
    }, 0);
    return () => clearTimeout(t);
  }, [location]);

  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/ongoing-project" element={<OngoingProjects />} />
        <Route path="/complete-project" element={<CompleteProjects />} />
        <Route path="/upcoming-project" element={<UpcomingProjects />} />
        <Route path="/park-grandeaur" element={<ParkGrandeur />} />
        <Route path="/news" element={<News />} />
        <Route path="/careers" element={<Careers />} />
        <Route path="/contact" element={<Contact />} />
      </Route>
    </Routes>
  );
}

export default App;